import { twMerge } from "tailwind-merge";

export function AnimatedSectionsHeading({ className, children }: { className?: string; children: React.ReactNode }) {
  return <div className={twMerge(`text-4xl/snug xs:text-5xl/snug md:text-6xl/snug 2xl:text-8xl/snug font-bold`, className)}>{children}</div>;
}
